// extracted by mini-css-extract-plugin
export default {"pagerBtn":"STEW_ipOXBsnS6npIfyg","bounce":"iGaoRpWchQNE_LD9VYw6"};